export const defaultModel = {
    dbKey: "?",
    deferred: false,
    enabled: true,
    extension: "auto",
    fileContent: "",
    fileData: null,
    fileMode: "",
    fileName: "",
    filePath: "",
    fileSize: 0,
    fileUri: null,
    info: null,
    optional: false,
    outputs: null,
    percentage: 0,
    spaceToTab: false,
    status: "init",
    toPosixLines: true,
};
